import * as styles from '../../styles.css';
import { ArticleParagraph2 } from '@cian/ui-kit';

export const mortgageInformationAccordions = {
  title: 'Важная информация об ипотеке',
  elements: [
    {
      title: 'Что представляет собой ипотека?',
      content: (
        <ArticleParagraph2>
          Ипотека – это разновидность кредита, предоставляемого заемщику под залог его недвижимости. Право собственности
          на купленную с использованием ипотеки квартиру остается у заёмщика, в то время как сама недвижимость находится
          в залоге у банка-кредитора до полного погашения долга.
        </ArticleParagraph2>
      ),
    },
    {
      title: 'Как можно снизить процентную ставку по ипотеке?',
      content: (
        <div>
          <ArticleParagraph2>
            Существует несколько способов, которые могут помочь в снижении ипотечной ставки:
          </ArticleParagraph2>
          <ol className={styles['list']}>
            <li>
              <ArticleParagraph2>
                Изучить предложения банков. Некоторые из них предлагают сниженную ставку своим зарплатным клиентам,
                предоставляют скидки за онлайн-оформление сделок или определенные виды страховки. Иногда выгодную ставку
                можно купить, то есть заплатить комиссию за снижение ставки по ипотеке. На длительной дистанции такая
                опция может заметно снизить общую переплату по процентам.
              </ArticleParagraph2>
            </li>
            <li>
              <ArticleParagraph2>
                Некоторые девелоперы также предлагают ипотеку по сниженным ставкам для квартир в новостройках, а на Циан
                можно найти объекты на вторичном рынке с понижением ставки на 4 процентных пункта. Такие предложения
                помечены специальной плашкой «Скидка на ипотеку 4%».
              </ArticleParagraph2>
            </li>
          </ol>
        </div>
      ),
    },
    {
      title: 'Стоит ли погашать ипотеку досрочно?',
      content: (
        <>
          <div className={styles['mb16']}>
            <ArticleParagraph2>
              Ответ на этот вопрос зависит от нескольких параметров: ставки по ипотеке, срока, финансовых возможностей
              заемщика.
            </ArticleParagraph2>
          </div>
          <div>
            <ArticleParagraph2>
              Например, выгода от досрочного погашения зависит от того, сколько времени прошло с момента заключения
              ипотечного договора. Если прошло менее половины срока кредита, досрочное погашение будет целесообразным: в
              первые годы значительная часть платежа приходится на проценты, а досрочный платеж отправится на погашение
              тела кредита.
            </ArticleParagraph2>
          </div>
        </>
      ),
    },
    {
      title: 'Какие типы платежей по ипотеке бывают?',
      content: (
        <>
          <div className={styles['mb16']}>
            <ArticleParagraph2>
              Любой кредитный платеж состоит из двух компонентов: основной суммы долга и процента за пользование
              заёмными средствами. При оформлении ипотеки банк может предложить два варианта платежей: аннуитетные и
              дифференцированные.
            </ArticleParagraph2>
          </div>
          <div className={styles['mb16']}>
            <ArticleParagraph2>
              Размер аннуитетного платежа устанавливается на весь срок кредита — заемщик выплачивает фиксированную сумму
              каждый месяц. Изменяется распределение основного долга и процентов внутри этой суммы. В первое время
              проценты составляют большую её часть, а на погашение основного долга направляется меньшая. К окончанию
              срока ипотеки — наоборот.
            </ArticleParagraph2>
          </div>
          <div className={styles['mb16']}>
            <ArticleParagraph2>
              Аннуитетный платеж удобен своей стабильностью: сумма и сроки известны заранее. Но общая переплата по
              процентам может быть выше, так как первое время заёмщик фактически расплачивается только по процентам, не
              уменьшая тело кредита.
            </ArticleParagraph2>
          </div>
          <div className={styles['mb16']}>
            <ArticleParagraph2>
              Дифференцированный платеж формируется иначе: сумма основного долга делится на равные части на весь срок
              кредита, а проценты начисляются каждый месяц на остаток кредитных средств. Поэтому первые платежи могут
              быть значительно выше, чем при аннуитетной схеме, но чем меньше сумма долга, тем ниже размер процентов, а
              значит — размер общего платежа.
            </ArticleParagraph2>
          </div>
          <div className={styles['mb16']}>
            <ArticleParagraph2>
              Такой подход помогает сократить общую сумму долга и быстрее расплатиться с кредитом, но на старте выплат
              по ипотеке потребуется больше средств. Это выгодно, если вы планируете досрочно погашать долг, так как в
              этом случае переплата банку по процентам будет ниже.
            </ArticleParagraph2>
          </div>
        </>
      ),
    },
    {
      title: 'Что будет, если пропустить ежемесячный платеж?',
      content: (
        <ArticleParagraph2>
          Все зависит от условий кредитного договора. В нём может быть оговорена допустимая задержка платежей по кредиту
          на срок от одного до пяти дней. В других случаях кредитор имеет право наложить на заёмщика штрафные санкции.
        </ArticleParagraph2>
      ),
    },
  ],
};
